import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ag-grid-paginator',
    templateUrl: './ag-grid-paginator.component.html',
    styleUrls: ['./ag-grid-paginator.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        NgSelectModule,
        TranslateModule
    ]
})
export class AgGridPaginatorComponent {
    @Input() currentPage = 1;
    @Input() totalCount = 0;
    @Input() pageSize = 20;
    @Input() pageSizeOptions: number[] = [20, 50, 70, 100];
    @Input() rangeFrom = 0;
    @Input() rangeTo = 0;
    @Input() isLoading = false;
    @Input() showPageSizeSelector = true;
    @Input() showRangeInfo = true;
    @Input() showPageInfo = true;
    @Input() showNavigationButtons = true;

    @Output() pageSizeChange = new EventEmitter<number>();
    @Output() pageChange = new EventEmitter<number>();

    get totalPages(): number {
        return Math.max(1, Math.ceil(this.totalCount / this.pageSize));
    }

    onPageSizeChange(size: number): void {
        if (!size) return;
        this.pageSizeChange.emit(size);
    }

    nextPage(): void {
        const lastPage = Math.max(1, Math.ceil(this.totalCount / this.pageSize));
        if (this.currentPage < lastPage) {
            this.pageChange.emit(this.currentPage + 1);
        }
    }

    prevPage(): void {
        if (this.currentPage > 1) {
            this.pageChange.emit(this.currentPage - 1);
        }
    }

    firstPage(): void {
        if (this.currentPage !== 1) {
            this.pageChange.emit(1);
        }
    }

    lastPage(): void {
        const last = this.totalPages;
        if (this.currentPage !== last) {
            this.pageChange.emit(last);
        }
    }
}
